<template>
  <div>
    <div class="position-resolver w-100 h-100"></div>
  </div>
</template>

<script>
import lottieWeb from "lottie-web";
import delayFunc from "@/utils/delay";
import { resolveResourceUrl } from "@/constants";

// const style

export default {
  mounted() {
    this.play();
  },
  methods: {
    async play(lottieId, options = { delay: 0, duration: 0 }, style = {}) {
      // lottieId = "Animation - 1710054575750.json";
      // lottieId = "Animation - 1707089690255.json";
      lottieId = "Animation - 1711005183995.json";

      if (this.animation) this.animation.destroy();

      const { delay, duration } = options;

      this.$el.querySelectorAll(".lottie__wrapper").forEach((el) => {
        this.$el.removeChild(el);
      });

      const $positionResolver = this.$el.querySelector(".position-resolver");

      // create child el
      const el = document.createElement("div");
      el.classList.add("lottie__wrapper");
      el.style.width = "100%";
      el.style.height = "100%";
      $positionResolver.appendChild(el);

      // scale은 부모에서 잡고, position은 자식에서 잡자
      // style resolve
      const scale = 0.2;

      this.$el.style.position = "absolute";
      this.$el.style.width = `${(100 * scale).toFixed()}%`;
      this.$el.style.height = `${(100 * scale).toFixed()}%`;
      this.$el.style.top = "50%";
      this.$el.style.left = "50%";
      this.$el.style.transform = "translate(-50%, -50%)";

      $positionResolver.style.position = "absolute";
      $positionResolver.style.transform = "translate(-150%, -150%)";
      el.style.rotate = "310deg";

      await delayFunc(delay);
      this.animation = lottieWeb.loadAnimation({
        container: el,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: resolveResourceUrl(lottieId, "lotties/foreground"),
      });

      try {
        // TODO: 없어도 될듯.. model 종료와 함께 정지된다
        await delayFunc(15 * 1000); // 혹시몰라서 15초로 해둔다
        if (this.animation) this.animation.destroy();
        this.$el.removeChild(el);
      } catch (error) {}
    },
    stop() {
      if (this.animation) this.animation.destroy();

      this.$el.querySelectorAll(".lottie__wrapper").forEach((el) => {
        this.$el.removeChild(el);
      });
    },
  },
  destroyed() {},
};
</script>

<style scoped>
.lottie-player__body {
  width: 100%;
  height: 100%;
}
</style>
